//@ts-nocheck
import "./style.css";
import Modal from "../modal";
import React, { useEffect, useState } from "react";

export default function GuidnessModal(props) {
  const { onClose, open, children } = props;
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(open);
    
  }, [open]);

  return (
    <Modal open={show} onClose={() => onClose?.()} className="guidnessModal">
      <Modal.Header />
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
}
